import React from "react"

import { styled } from "@mui/material/styles"
import {
	DataGrid,
	GridColDef,
	GridPaginationModel,
	GridSortModel,
} from "@mui/x-data-grid"

import {
	OrderType,
	PaginatedResponse, PaginationInfo, SearchFilter,
} from "models"

import { PaginationActions } from "./pagination-actions"


export const SbDatagrid = styled(DataGrid)(({ theme }) => ({
	"&": {
		backgroundColor: theme.palette.background.default,
	},
	"& .MuiDataGrid-cell:focus": {
		outline: "none",
	},
}))


interface SbPaginatedDatagridProps {
	columns: GridColDef[]
	data: PaginatedResponse<any> | null
	pagination: SearchFilter

	initialSorting?: GridSortModel

	onPaginationChanged?: (pageId: number, pageSize: number) => void
	onSortChanged?: (orderBy: string | null, orderType: OrderType | null) => void
}
interface SbPaginatedDatagridState {
	displayData: PaginatedResponse<any>
}
export class SbPaginatedDatagrid extends React.Component<SbPaginatedDatagridProps, SbPaginatedDatagridState> {
	static defaultProps = {
		initialSorting: [{ field: "id", sort: "asc" }],
	}

	private readonly defaultPagination: PaginationInfo = {
		pageCount: 10,
		currentPage: 0,
		totalRecords: 0,
		totalPages: 0
	}

	private readonly emptyData: PaginatedResponse<any> = {
		items: [],
		pagination: this.defaultPagination
	}

	constructor(props: SbPaginatedDatagridProps) {
		super(props)
		this.state = {
			displayData: this.props.data ?? this.emptyData,
		}

		console.log(this.props.columns)
		console.log(this.props.pagination)
	}

	componentDidUpdate(prevProps: Readonly<SbPaginatedDatagridProps>, prevState: Readonly<SbPaginatedDatagridState>, snapshot?: any) {
		if (this.props.data && this.props.data !== this.state.displayData) {
			this.setState(() => ({
				displayData: this.props.data!,
			}))
		}
	}

	private handlePagination = (model: GridPaginationModel) => {
		if (model.pageSize !== this.props.pagination.pageSize) {
			this.props.onPaginationChanged?.(0, model.pageSize)
		}
		else {
			this.props.onPaginationChanged?.(model.page, model.pageSize)
		}
	}

	private handleSorting = (model: GridSortModel) => {
		let orderBy: string | null = null
		let orderType: OrderType | null = null
		if (model.length !== 0) {
			orderBy = model[0].field

			if (model[0].sort === "asc") {
				orderType = OrderType.ASCENDING
			} else if (model[0].sort === "desc") {
				orderType = OrderType.DESCENDING
			} else {
				orderType = null
			}
		}

		this.props.onSortChanged?.(orderBy, orderType)
	}

	render() {
		return (
			<SbDatagrid
				columns={this.props.columns}
				rows={this.state.displayData.items}
				paginationModel={{ pageSize: this.props.pagination.pageSize, page: this.props.pagination.pageId }}
				rowCount={this.state.displayData.pagination.totalRecords}
				autoHeight
				pagination
				paginationMode="server"
				pageSizeOptions={[10, 25, 50,]}
				sortingMode="server"
				slotProps={{
					pagination: {
						ActionsComponent: PaginationActions,
						page: this.props.pagination.pageId
					},
				}}
				disableRowSelectionOnClick
				disableColumnMenu
				initialState={{
					sorting: {
						sortModel: this.props.initialSorting,
					},
				}}
				onPaginationModelChange={this.handlePagination}
				onSortModelChange={this.handleSorting}
			/>
		)
	}
}
